import { lazy } from 'react';

const DayTradingDashboard = lazy(() => import(/* webpackChunkName: "dt-container" */ './Container'));

export {DayTradingDashboard}